import React, {useState} from 'react';
import { Card, Button, Form, Dimmer, Grid, Avatar } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PhotoModal from '../../components/modal/photoModal';

const ProductViewModal = ({ recordId, closeMainModal }) => {
  const { data, loading } = useFetch(`products/${recordId}`);
  const [modalPhoto, setModalPhoto] = useState(null)

  return (
    <Card>
      {modalPhoto &&
        <PhotoModal photo={data.image} close={() => setModalPhoto(null)} />
      }

      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>View Product</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>
        {!loading && data &&
          <Card.Body>
            <Form>
              <Form.FieldSet>
                <Grid.Row>
                  <Grid.Col>
                    <Form.Label>Image</Form.Label>
                    <Avatar size="md" imageURL={data.image} className="mb-2 clickable"
                      onClick={() => setModalPhoto(data.image)} />

                    <Form.Label>Name</Form.Label>
                    <div className="normalText">{data.name}</div>

                    <Form.Label>Description</Form.Label>
                    <div className="normalText">{data.description}</div>
                  
                    <Form.Label>Price</Form.Label>
                    <div className="normalText">{data.price}</div>

                    <Form.Label>URL</Form.Label>
                    {data.productUrl
                      ? <a href={data.productUrl} target="_blank" rel="noreferrer"
                           style={{ textDecoration: 'underline', color: '#467fcf' }}>
                          {data.productUrl}
                        </a>
                      : <div className="normalText text-muted">—</div>}
                  </Grid.Col>
                </Grid.Row>
              </Form.FieldSet>
            </Form>
          </Card.Body>
        }
      </Dimmer>
    </Card>
  )
}

export default ProductViewModal;